import { useContext } from 'react';
import { ChatContext, ChatContextValue } from '../context/ChatProvider';

export function useChat(): ChatContextValue {
  const ctx = useContext(ChatContext);
  if (!ctx) throw new Error('useChat must be used inside <ChatProvider>');
  return ctx;
}
